module.exports = __webpack_public_path__ + "img/HIDDEN-ANCILLARY-BUILDINGS.726000f2.jpg";